export const tagTemplates = {
  Container: [
    '<script>',
    '    (function(d,s,i)',
    '    {',
    '        var f,j;',
    '        f=d.getElementsByTagName(s)[0];',
    '        j=d.createElement(s);',
    '        j.async=true;',
    '        j.src=\'https://mtag.microsoft.com/tags/\'+i+\'.js\';',
    '        j.referrerPolicy=\'no-referrer-when-downgrade\';',
    '        f.parentNode.insertBefore(j,f);',
    '    })',
    '    (document,\'script\',\'TAGID\');',
    '</script>',
  ],
  DMC: [
    '<script>',
    '    (function(d,s,i)',
    '    {',
    '        var f,j;',
    '        f=d.getElementsByTagName(s)[0];',
    '        j=d.createElement(s);',
    '        j.async=true;',
    '        j.src=\'https://mtag.microsoft.com/tags/\'+i+\'.js\';',
    '        j.referrerPolicy=\'no-referrer-when-downgrade\';',
    '        f.parentNode.insertBefore(j,f);',
    '    })',
    '    (document,\'script\',\'TAGID\');',
    '</script>',
  ],
  UET: [
    '<script>',
    '    (function(w,d,t,r,u)',
    '    {',
    '        var f,n,i;',
    '        w[u]=w[u]||[],f=function()',
    '        {',
    '            var o={ti:"TAGID", PLATFORM_PARAM, SPA_PARAM};',
    '            o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")',
    '        },',
    '        n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function()',
    '        {',
    '            var s=this.readyState;',
    '            s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)',
    '        },',
    '        i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)',
    '    })',
    '    (window,document,"script","//bat.bing.com/bat.js","uetq");',
    '</script>',
  ],
};
